export enum VehicleNoteFI {
  VehicleSize = "vehicleSize",
  AdditionalTentSize = "additionalTentSize",
}
